import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineStatistics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    viewBox="0 0 15 15"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M2.75 8V1.7A1.05 1.05 0 0 1 3.8.65h6.825L14.3 4.325v8.925a1.05 1.05 0 0 1-1.05 1.05H8M.65 14.3 5.9 9.05M1.175 10.1a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05M5.375 14.3a.525.525 0 1 0 0-1.05.525.525 0 0 0 0 1.05"
    />
  </svg>
);
export default SvgStreamlineStatistics;
